import {
  Alert,
  Button,
  Icon,
  SPACING,
  Typography
} from '@themenu/design-system'
import { useAuthorize } from 'components/Authorize/useAuthorize'
import { PERMISSIONS } from '../../../constants'
import { useCardsExpireSoonCount } from 'providers/cards/useCardsExpireSoonCount'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useSessionStore } from 'store/session'
import { useSessionStorage } from 'usehooks-ts'

const CARDS_EXPIRING_SOON_DISMISSED_KEY =
  '@SwileCorporates:CardsExpiringSoonDismissed'

const CardsExpiringSoonAlert: React.FC = () => {
  const hasPermissionToCards = useAuthorize({
    permissions: [PERMISSIONS.MANAGE_CARDS, PERMISSIONS.VIEW_CARDS]
  })
  const {
    user: { corporate }
  } = useSessionStore()

  const [isDismissed, setIsDismissed] = useSessionStorage(
    CARDS_EXPIRING_SOON_DISMISSED_KEY,
    false
  )

  const path = usePathname()

  const isEnabled =
    process.env.NEXT_PUBLIC_IS_CARDS_EXPIRING_ALERT_ENABLED === 'true'

  const { data: cardsExpiringSoon } = useCardsExpireSoonCount(
    isEnabled && hasPermissionToCards,
    corporate?.id
  )

  if (
    !cardsExpiringSoon?.numberOfEmployeesWithCardsToExpireSoon ||
    !hasPermissionToCards ||
    !isEnabled ||
    path.includes('/cards') ||
    isDismissed
  )
    return null

  return (
    <>
      <div className="h-120"></div>
      <div className="fixed bottom-0 left-0 right-0 z-[1] flex justify-center items-center w-full p-4">
        <Alert
          severity="warning"
          mb={SPACING.xxs}
          className="max-w-5xl"
          onClose={() => setIsDismissed(true)}
        >
          <div className="grid gap-16 grid-cols-[auto,1fr,auto]">
            <div>
              <Icon name="warning-alt" size={20} />
            </div>
            <div>
              <Typography variant="body" weight="medium" className="underline">
                Há {cardsExpiringSoon?.numberOfEmployeesWithCardsToExpireSoon}{' '}
                colaborador
                {cardsExpiringSoon?.numberOfEmployeesWithCardsToExpireSoon > 1
                  ? 'es'
                  : ''}{' '}
                com o cartão próximo ao vencimento
              </Typography>
              <Typography variant="callout">
                Não há custos adicionais para substituição de cartão: peça já a
                segunda via e evite que seus colaboradores fiquem sem poder
                utilizar a Swile!
              </Typography>
            </div>
            <div className="self-center">
              <Link href="/cards/expiring-soon" passHref legacyBehavior>
                <Button size={32} component="a">
                  Substituir cartões
                </Button>
              </Link>
            </div>
          </div>
        </Alert>
      </div>
    </>
  )
}

export default CardsExpiringSoonAlert
